import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
    TenantStateService,
    type Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse,
} from '@wealthlane/api-services/wealthlane-identity-service';

interface SandboxLockStatePayload {
    tenantId: string;
    lockState: number;
}

const useSandboxLockState = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
    onClose: () => void
): UseMutationResult<
    Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse | undefined,
    unknown,
    SandboxLockStatePayload,
    unknown
> => {
    const queryClient = useQueryClient();

    return useMutation(
        async (payload: SandboxLockStatePayload) => {
            return await handleRequest(
                TenantStateService.putApiIdentityApiSandboxLockState(
                    payload.tenantId,
                    payload.lockState as any
                )
            );
        },
        {
            onSuccess: async (data) => {
                toast.success(
                    <ToastComponent
                        label='Success'
                        message={data?.message ?? 'Sandbox status updated successfully.'}
                    />
                );
                await queryClient.invalidateQueries('getSwitchSandboxList');
                onClose && onClose();
            },
            onError: (err) => {
                onClose && onClose();
                console.log('error', err);
            },
        }
    );
};

export default useSandboxLockState;
